export type ChatMessageUserType =
  | 'user'
  | 'planner'
  | 'planner_account'
  | 'bot'
  | 'system'
  | 'staff'
  | 'entrance'

export const BizChatMessageUserType: ChatMessageUserType[] = [
  'planner',
  'planner_account',
  'staff',
  'entrance',
] as const
